export enum TYPES_SOURCE_OPTIONS {
  SYSTEM = 'SYSTEM',
  OBJECT = 'OBJECT',
}

export const SOURCE_SELECTION_OPTIONS = [
  {
    id: TYPES_SOURCE_OPTIONS.SYSTEM,
    label: TYPES_SOURCE_OPTIONS.SYSTEM,
  },
  {
    id: TYPES_SOURCE_OPTIONS.OBJECT,
    label: TYPES_SOURCE_OPTIONS.OBJECT,
  },
]

export const COMMAND_CACHE_TIME = 30000
